import api from './api.service';

export interface WhiteLabelConfig {
  logo_url?: string;
  custom_name?: string;
  custom_url?: string;
}

const whiteLabelApi = {
  /**
   * Get white label configuration
   * @param forSettings - If true, returns only the user's own config (for settings page). If false/undefined, returns config with domain fallback (for layout/navbar)
   */
  getConfig: async (forSettings = false) => {
    const params = forSettings ? '?forSettings=true' : '';
    const response = await api.get(`/v1/white-label${params}`);
    return response;
  },

  /**
   * Update white label configuration
   */
  updateConfig: async (config: Partial<WhiteLabelConfig>) => {
    const response = await api.put('/v1/white-label', config);
    return response;
  },

  /**
   * Upload logo
   */
  uploadLogo: async (file: File) => {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await api.post('/v1/white-label/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
};

export default whiteLabelApi;
